import React from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import "./Subtitle.css"

const blockchain = (props) => {
    return (
        <Tooltip id="tooltip" {...props}>
            A distributed database that is used to maintain a continuously growing list of records, called blocks. 
            Anybody can add data to the chain, but because (in practice) all users have a copy of the chain, data can be verified based on majority consensus.
        </Tooltip>
    );
}

const index = (props) => {
    return (
        <Tooltip id="tooltip" {...props}>
            This is the position of the block in the chain. The genesis block is the 0th block and subsequent blocks are numbered starting from 1.
        </Tooltip>
    );
}

const timestamp = (props) => {
    return (
        <Tooltip id="tooltip" {...props} >
            The date and time a block was created.
        </Tooltip>
    );
}

const data = (props) => {
    return (
        <Tooltip id="tooltip" {...props} >
            The data stored in a block, which in this case, is text. But for cryptocurrencies (e.g. bitcoin), their blockchain data is the transaction information between users. 
        </Tooltip>
    );
}

const prevHash = (props) => {
    return (
        <Tooltip id="tooltip" {...props} >
            The hash of the preceding block in the chain.
        </Tooltip>
    );
}

const nonce = (props) => {
    return (
        <Tooltip id="tooltip" {...props} >
            The number you try to find in order to make the block have a valid hash.
        </Tooltip>
    );
}

const hash = (props) => {
    return (
        <Tooltip id="tooltip" {...props} >
            The 'ID' of the block. It is simply a long string of characters generated by the SHA-256 hash function that is unique to each block's contents. Two unique blocks will always have a different hash and the same data will always have the same hash.
        </Tooltip>
    );
}

const Subtitle = () => {
    return (
        <p className="subtitle">
            Welcome to my  
            <OverlayTrigger
                placement="top"
                delay={{ show: 150, hide: 300 }}
                overlay={blockchain}
            >
                <span className="text-info"><strong> blockchain </strong></span>
            </OverlayTrigger>
            demo! Enter some data and add a
            <span className="text-warning"><strong> new block</strong></span> to begin.
          Each block has an 
          <OverlayTrigger
                placement="top"
                delay={{ show: 150, hide: 300 }}
                overlay={index}
            >
                <span className="text-info"><strong> index</strong></span>
            </OverlayTrigger>
          ,
            <OverlayTrigger
                placement="bottom"
                delay={{ show: 150, hide: 300 }}
                overlay={timestamp}
            >
                <span className="text-info"><strong> timestamp</strong></span>
            </OverlayTrigger>
          ,
          <OverlayTrigger
                placement="bottom"
                delay={{ show: 150, hide: 300 }}
                overlay={data}
            >
                <span className="text-info"><strong> data</strong></span>
            </OverlayTrigger>
          ,
          <OverlayTrigger
                placement="bottom"
                delay={{ show: 150, hide: 300 }}
                overlay={prevHash}
            >
                <span className="text-info"><strong> previous hash</strong></span>
            </OverlayTrigger>
          , and
          <OverlayTrigger
                placement="bottom"
                delay={{ show: 150, hide: 300 }}
                overlay={nonce}
            >
                <span className="text-info"><strong> nonce</strong></span>
            </OverlayTrigger>
          , which are used to compute the block's
          <OverlayTrigger
                placement="bottom"
                delay={{ show: 150, hide: 300 }}
                overlay={hash}
            >
                <span className="text-info"><strong> hash</strong></span>
            </OverlayTrigger>
            . Hover above each item to learn more
          about them!
        </p>
    );
}

export default Subtitle;

